export * from './customer-details';
